export default __webpack_public_path__ + "static/media/logo-or-avner.635912d1.webp";